import React, { useState, useEffect } from "react"
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import { FaBars } from 'react-icons/fa'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { FaPlus } from 'react-icons/fa'
import { apiURL, sitePath } from 'config/globals'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import Breadcrumbs from 'components/Breadcrumbs'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const Users = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [dbUsers, setDbUsers] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const navigate = useNavigate()
    
    useEffect(() => {
        const start = async () => {
            const user = await checkAuth(navigate)
            setCurrentUser(user)
            getDbUsers(user.role)
        }
        start()
    }, [])

    const getDbUsers = async (currentRoleId) => {
        const response = await axios.get(`${apiURL}/get-db-users/`)
        
        if (!response.data.success) {
            setErrorMessage(response.data.error || response.data)
            return
        }

        const result = response.data.rows.filter(dbUser => dbUser.roleId >= currentRoleId)

        for (const user of result) {
            if (!user.entityId) {
                continue
            }

            const response = await axios.get(`${apiURL}/get-museum/${user.entityId}`)

            if (!response.data.success) {
                continue
            }

            user.entityName = response.data.item.name
        }
        
        setDbUsers(result)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <Sidebar selectedItem="users" currentUser={currentUser} />
            <main>
                <Breadcrumbs items={[['Users']]} />
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>Users</h1>
                    </div>
                    <Button variant="outline-primary" className="float-end px-4" href={`${sitePath}/users/new`}>
                        <FaPlus /> Add User
                    </Button>
                </header>
                {dbUsers &&
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Role</th>
                                <th>Email</th>
                                <th>Museum</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dbUsers
                                .map(dbUser => (
                                    <tr key={dbUser.name}>
                                        <td>
                                            {dbUser.id}
                                        </td>
                                        <td>
                                            <Link to={`/users/${dbUser.id}`}>{dbUser.name}</Link>
                                        </td>
                                        <td>
                                            {dbUser.roleName}
                                        </td>
                                        <td>
                                            {dbUser.email}
                                        </td>
                                        <td>
                                            <Link to={`/museums/${dbUser.entityId}`}>{dbUser.entityName}</Link>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                }
                {dbUsers.rows &&
                    <small>
                        {dbUsers.rows.length === 1 ? '1 usuari' : `${dbUsers.rows.length} usuaris`}
                    </small>
                }
                {errorMessage && 
                    <Alert key='errorMessage' variant='danger'>
                        {errorMessage}
                    </Alert>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default Users